//电量报表
const repPowerEn = {
  repPowerLang: {
    电量报表: 'Electricity report',
    站点汇总展示所有站点报表数据支持按日展示31天按月展示一年内数据:
      'Site summary Displays the report data of all sites. The report data can be displayed on a daily basis for 31 days or on a monthly basis for one year.',
    站点汇总: 'Site summary',
    单站报表: 'Single station report',
    时间范围: 'Time frame',
    开始日期: 'Start date',
    结束日期: 'Finish date',
    开始月份: 'Starting month',
    结束月份: 'End month',
    开始年份: 'Starting year',
    结束年份: 'End year',
    请选择: 'Please select',
    查询: 'Query',
    重置: 'Reset',
    报表导出: 'Report export',
    站点名称: 'Site name',
    充电量: 'Charge capacity',
    尖: 'Tip',
    峰: 'Peak',
    平: 'Flat',
    谷: 'Valley',
    总: 'Total',
    放电量: 'Discharge capacity',
    综合效率: 'Overall efficiency',
    暂无数据: 'No data available',
    按日: 'Daily',
    按月: 'Monthly',
    按年: 'Yearly ',
    请选择时间范围: 'Please select a time frame!',
    报表类型: 'Report type',
    时段报表: 'Period report',
    日报表: 'Daily statement',
    月报表: 'Monthly statement',
    年报表: 'Yearly statement',
    选择站点: 'Select site',
    日期: 'Date',
    请选择站点: 'Please select a site!',
    总计: 'Total',
    选择日期: 'Please select a date',
    时段数据: 'Period data',
    折线图: 'Line chart',
    柱状图: 'Bar chart',
    表格: 'Form',
    原始数据: 'Row data',
    当日数据: 'Data of the day',
    累计数据: 'Cumulative data',
    当日数据导出: 'Daily data export',
    累计数据导出: 'Cumulative data export',
    数据导出: 'Data export',
    起止时间: 'Beginning and ending time',
    取消: 'Cancel',
    确定: 'Confirm'
  }
}
export default repPowerEn
